import * as Application from 'expo-application'
import * as Clipboard from 'expo-clipboard'
import * as Updates from 'expo-updates'
import { Pressable, Text } from 'native-base'
import { Platform } from 'react-native'

import { ENV } from '~constants'
import { useCallback, useTranslation } from '~hooks'

const webVersion = ENV.WEB_APP_VERSION

export const Version = ({ onPress }: { onPress: () => void }) => {
  const { t } = useTranslation()

  const version =
    Platform.OS !== 'web'
      ? `${Application.applicationName}: ${Application.nativeApplicationVersion} (${
          Application.nativeBuildVersion
        })\n${Updates?.updateId ? 'update: ' + Updates?.updateId : ''}`
      : t('common.web_version', { webVersion })

  const handleShortPress = useCallback(async () => {
    await Clipboard.setStringAsync(version)
  }, [version])

  return (
    <Pressable onPress={handleShortPress} onLongPress={onPress} delayLongPress={7000} pt={6}>
      <Text textAlign="center" color="gray.400">
        {version}
      </Text>
    </Pressable>
  )
}
